module.exports = __webpack_public_path__ + "img/cuenta.db27e566.svg";